module.exports = __webpack_public_path__ + "img/image12.69032295.png";